import { createReducer, on } from '@ngrx/store';
import { setPrices } from './prices.actions';

export interface State {
  quotePrices; // quotePrices; TODO: crear modelo de quotePrices
}

export const initialState = JSON.parse(localStorage.getItem('quotePrices')) || {};

export const pricesReducer = createReducer(
  initialState,

  on(setPrices, (state, { prices }) => ({ ...prices }))
);
